<template>
  <div class="my_customer">
    <van-sticky>
      <van-nav-bar title="我的顾客" left-arrow @click-left="goback()" />
    </van-sticky>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :immediate-check="false">
        <van-tabs :v-modelActive="active" title-active-color="#FCA33D" color="#FCA33D">
          <van-tab v-for="(items, indexs) in title" :key="indexs" :title="items.name" :disabled="items.disable">
            <div class="flex-row ai-center fs12 customer_tag">
              <van-icon name="star-o" color="#E7405C" />
              代表已成为分销商团队
            </div>
            <div class="customer_list" v-for="(item, index) in dataList" :key="index">
              <div class="distribution_data">
                <van-image round width="40" height="40" :src="item.portrait" />
                <div class="data_detail ">
                  <div class="detail_list">
                    <div class="fs15 line1 ">{{item.realname || '暂无信息'}}</div>
                    <div class="fs9 m-t10 color999 ">
                      注册时间:{{item.createtime || '暂无信息'}}
                    </div>
                  </div>
                  <div class="detail_number">
                    <div>消费：{{item.orderInfoSum+'元' || '暂无信息'}}</div>
                    <div>{{item.orderInfoCount+'个订单' || '暂无信息'}}</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 分销数据 -->
            <div class="customer_list" v-for="(item, index) in dbyuserList" :key="index">
              <div class="distribution_data">
                <van-image round width="40" height="40" :src="item.headimgurl" />
                <div class="data_detail ">
                  <div class="detail_list">
                    <div class="fs15 line1 ">{{item.nickName || '暂无信息'}}</div>
                    <div class="fs9 m-t10 color999 ">
                      注册时间:{{item.ctime || '暂无信息'}}
                    </div>
                  </div>
                  <div class="detail_number">
                    <div>消费：{{item.sum_price+'元' || '暂无信息'}}</div>
                    <div>{{item.usercount+'个订单' || '暂无信息'}}</div>
                  </div>
                </div>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import { Button, NavBar, Icon, Sticky, Tab, Tabs, Image, Toast, PullRefresh, List, Notify } from "vant";
export default {
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [NavBar.name]: NavBar,
    [Sticky.name]: Sticky,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Image.name]: Image,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
  },
  data() {
    return {
      loading: false, //底部加载状态
      finished: false, //底部是否完成状态
      isLoading: false,
      dataList: [],
      active: 0,
      title: [{ name: "一级(1)", disable: false }, { name: " ", disable: true }, { name: " ", disable: true }, { name: " ", disable: true }],
      page: 1,
      size: 20,
      total:0,
      userData: {
        nickname: "未登录",
        orderInfoCount_1: 0,
        orderInfoCount_2: 0,
        orderInfoCount_3: 0,
        orderInfoCount_5: 0,
        portrait: "",
        telephone: "",
      },
      dbyuserList:[],
    };
  },
  mounted() {
    this.getMyCustomerList();
    this.getLoginUserInfo();
  },
  methods: {
    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },

    //跳转立即租赁
    toSiteLease() {
      this.$router.push({ path: "/home/siteLease" });
    },

    //跳转立即预约
    toSiteSubscribe() {
      this.$router.push({ path: "/home/siteSubscribe" });
    },

    //我的顾客
    getMyCustomerList(isLoadMore = false) {
      let that = this;
      that.$api.userH5ApplyCustomerAPI({
        page: that.page,
        size: that.size,
      }).then(function(res) {
        if (res.data.code == 200) {
          if (that.page > 1) {
            that.dataList = (!isLoadMore && res.data.dataList.length != 0) ? res.data.dataList : that.dataList;
            that.dataList = (isLoadMore && res.data.dataList.length != 0) ? that.dataList.contact(res.data.dataList) : that.dataList
          } else {
            that.dataList = res.data.dataList
          }
          that.total = res.data.total
          if (res.data.dataList.length == 0 && that.page > 1)
            that.finished = true
        } else {
          Notify({ type: "danger", message: '接口返回异常：' + res.data.message });
        }
      }).catch(function(err) {
        Notify({ type: "danger", message: JSON.stringify(err) });
      })
    },

    //下拉刷新
    onRefresh() {
      let that = this
      that.page = 1;
      setTimeout(() => {
        that.isLoading = false
        that.getMyCustomerList()
      }, 1000);
    },

    //上拉加载
    onLoad() {
      let that = this;
      that.page = that.page + 1
      setTimeout(() => {
        that.getMyCustomerList(true);
      }, 1000);
    },

    //获取登报云我的顾客
    getDbyMyCustomer(){
      let that = this
      that.$axios.get("https://my.1688tg.com/dengbao/Api/getMyCustomer?phone="+this.userData.telephone).then(res => {
        //获取你需要用到的数据
       console.log('dbyuserList',res)
       res = JSON.parse(res.data.data)
       that.dbyuserList = res
      })
    },

    //获取登录用户信息
    getLoginUserInfo() {
      let that = this;
      that.$api
        .getLoginUserInfo("")
        .then(function(res) {
          if (res.data.code === 200) {
            that.userData = res.data.data;
            that.getDbyMyCustomer()
          }
        })
        .catch(function(err) {
          console.log("error", err);
        });
    },
  }
};

</script>
<style lang="less" scoped>
.my_customer {
  .customer_tag {
    border-top: 10px solid #f3f3f1;
    padding: 15px 10px;
  }

  .van-tabs {
    border-bottom: 10px solid #f3f3f1;
  }

  .customer_list {
    border-top: 10px solid #f3f3f1;
    font-size: 11px;
    color: #999;

    //分销数据
    .distribution_data {
      padding: 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .data_detail {
        display: flex;
        justify-content: space-between;
        color: #000;
        align-items: center;

        .detail_list {
          display: flex;
          flex-flow: column; //垂直排列
          width: 200px;
          padding-right: 10px;
        }

        .detail_number {
          border-left: 1px solid #dfdfdf;
          padding-left: 10px;
          font-size: 8px;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/layout/distribution/myCustomer.vue